export enum BudgetValidation {
  IndirektaKostnaderOverLonekostnader = 'IndirektaKostnaderOverLonekostnader',
  FinansiarRequired = 'BudgetFinansiarRequired',
  Under10KWarning = 'Budget10kWarning',
  EgenFinansieringRequired = 'BudgetEgenFinansieringRequired',
  MottagareNotFinansiar = 'BudgetMottagareNotFinansiar',
  KostnaderRequired = 'BudgetKostnaderRequired',
}
